class a extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.setUpObservers();
  }
  setUpObservers() {
    const t = {
      root: null,
      threshold: 0.1
    }, e = new IntersectionObserver((n) => {
      n.forEach((s) => {
        s.isIntersecting && (this.render(), e.disconnect());
      });
    }, t);
    e.observe(this);
  }
  hideSection() {
    const t = this.querySelector(
      `${this.dataset.sectionId}-recommendations`
    );
    t && t.remove();
  }
  render() {
    this.dataset.loading = "true";
    const t = `${this.dataset.baseUrl}${this.dataset.params}&section_id=${this.dataset.sectionId}`;
    fetch(t).then((e) => e.text()).then((e) => {
      if (e) {
        const s = new DOMParser().parseFromString(e, "text/html").querySelector(
          `#shopify-section-${this.dataset.sectionId}`
        );
        if (s) {
          const o = s.querySelectorAll("simple-slide");
          let i = o.length;
          if (o.forEach((r) => {
            var c;
            (c = r.textContent) != null && c.toLowerCase().includes("pre-owned") && (r.remove(), i--);
          }), i === 0) {
            this.hideSection();
            return;
          }
          this.innerHTML = s.innerHTML || "";
        }
        this.dataset.loading = "false";
      } else
        this.hideSection();
    }).catch((e) => {
      console.error("Error fetching product recommendations:", e), this.dataset.loading = "false", this.hideSection();
    });
  }
}
window.customElements.define("product-recommendations", a);
export {
  a as ProductRecommendations
};
